import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "@/utils/axiosInstance";
import { handleThunkError } from "@/utils/thunkErrorHandler";
import { Params } from "@/types";

const endpoint = {
  userServiceCommission: "/user-service-commission",
};

export const fetchUserServiceCommissions = createAsyncThunk(
  "userServiceCommission/fetchUserServiceCommissions",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.userServiceCommission, {
        params,
      });
      return response.data;
    } catch (error) {
      return handleThunkError(
        error,
        thunkAPI,
        "Erro ao carregar comissões personalizadas",
      );
    }
  },
);

export const createUserServiceCommission = createAsyncThunk(
  "userServiceCommission/createUserServiceCommission",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        endpoint.userServiceCommission,
        data,
      );
      return response.data;
    } catch (error) {
      return handleThunkError(
        error,
        thunkAPI,
        "Erro ao criar comissão personalizada",
      );
    }
  },
);

export const updateUserServiceCommission = createAsyncThunk(
  "userServiceCommission/updateUserServiceCommission",
  async ({ id, data }: { id: number; data: any }, thunkAPI) => {
    try {
      const response = await axiosInstance.put(
        `${endpoint.userServiceCommission}/${id}`,
        data,
      );
      return response.data;
    } catch (error) {
      return handleThunkError(
        error,
        thunkAPI,
        "Erro ao atualizar comissão personalizada",
      );
    }
  },
);

export const deleteUserServiceCommission = createAsyncThunk(
  "userServiceCommission/deleteUserServiceCommission",
  async (id: number, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(
        `${endpoint.userServiceCommission}/${id}`,
      );
      return { ...response.data, deletedId: id };
    } catch (error) {
      return handleThunkError(
        error,
        thunkAPI,
        "Erro ao excluir comissão personalizada",
      );
    }
  },
);
